import React, { useEffect, useState, useRef } from 'react'
import styled from '@emotion/styled'
import Spinner from './spinner.js'
import { BrowserUtils } from '../../utils/siteUtils'

const Container = styled('div')`
  width: 100%;
  position: relative;
`

const LoadingWrapper = styled('div')`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 50px;
  width: 100%;
  z-index: 0;
`

const ComponentContainer = styled('div')`
  background-color: white;
  position: relative;
  z-index: 3;
  width: 100%;
  max-width: ${props => props.maxWidth};
  margin: auto;
`

const implementedComponents = ['condition', 'imagecapture', 'breadcrumb', 'vehicleDetails', 'vehicleDetailsKeysMods', 'landing']

const WebComponentContainer = ({ children, pageLoadingComplete, withLoader, location, maxWidth = '95%' }) => {
  const componentWrapperReference = useRef(null)

  const [height, setHeight] = useState(0)

  const onLoad = () => {
    setHeight(componentWrapperReference?.current?.scrollHeight)
  }
  useEffect(() => {
    onLoad()
  })

  useEffect(() => {
    if (BrowserUtils.isIframe()) {
      if (location !== 'breadcrumb') {
        let adjustedHeight = 0
        if (location === 'landing') {
          adjustedHeight = height
        } else {
          adjustedHeight = height !== 0 ? height + 300 : height // adjusted for breadcrumb
        }
        setTimeout(function () {
          BrowserUtils.emitComponentSize(adjustedHeight, location)
        }, 500)
      }
    }
  }, [height, location])

  return (
    <Container ref={componentWrapperReference} id={'BodyDivFlex'} maxWidth={maxWidth}>
      {/* 
      // Because eventing is inconsistent with the UI, 
      // this Loader is meant to be always on. 
      // The web component will render on top of it when it is ready. 
      */}
      {withLoader && <LoadingWrapper>{location === 'landing' ? <Spinner size="30px"></Spinner> : <ico-loading-spinner />}</LoadingWrapper>}
      <ComponentContainer maxWidth={maxWidth} id={'WebComponentContainer-' + location}>
        <style>{`:root{font-size:16px;}`}</style>
        {// ICO Web compnents need to be rendered on the 2nd render cycle to resolve
        // any event timing issues on first load.
        !pageLoadingComplete ? <></> : children}
      </ComponentContainer>
    </Container>
  )
}

WebComponentContainer.displayName = 'WebComponentContainer'

export default WebComponentContainer
